import { Variant } from 'modules/productDetail/types'

export default function pdpLdJson(
  product: Variant,
  currency = '€',
  description = '',
  shippingRate?: number
) {
  const ldJson = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: product.title,
    image:
      product.images?.imageWeb.length > 0
        ? 'https://res.cloudinary.com/lusini/w_1200,h_1200,q_80,c_pad,f_auto/' +
          product.images?.imageWeb[0].url
        : '',
    description: description !== '' ? description : product.description,
    mpn: product.containerID,
    sku: product.sku,
    brand: {
      '@type': 'Brand',
      name: product.brand
    },

    offers: {
      '@type': 'Offer',
      priceCurrency: currency,
      price: product.prices?.packPriceGross,
      itemCondition: 'http://schema.org/NewCondition',
      availability: 'http://schema.org/InStock',
      seller: {
        '@type': 'Organization',
        name: 'LUSINI'
      },
      shippingDetails: {
        '@context': 'https://schema.org',
        '@type': 'OfferShippingDetails',
        deliveryTime: {
          '@type': 'ShippingDeliveryTime',
          businessDays: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: [
              'https://schema.org/Monday',
              'https://schema.org/Tuesday',
              'https://schema.org/Wednesday',
              'https://schema.org/Thursday',
              'https://schema.org/Friday'
            ]
          },
          cutoffTime: '14:00:15Z',
          handlingTime: {
            '@type': 'QuantitativeValue',
            minValue: 1,
            maxValue: product.deliveryDays || null,
            unitCode: 'd'
          },
          transitTime: {
            '@type': 'QuantitativeValue',
            minValue: 1,
            maxValue: 3,
            unitCode: 'd'
          }
        },
        shippingRate: shippingRate
          ? {
              '@type': 'MonetaryAmount',
              value: shippingRate,
              currency: 'EUR'
            }
          : null
      }
    }
  }

  if (
    product.productReviews?.productReviewAvg &&
    product.productReviews?.productReviewCount
  ) {
    return {
      ...ldJson,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: product.productReviews?.productReviewAvg,
        reviewCount: product.productReviews?.productReviewCount
      }
    }
  }
  return ldJson
}
